import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const Message = styled.span`
  font-size: 26px;
  color: ${(props) => props.theme.colors.danger};
`;

export const Contact = styled.span`
  font-size: 18px;
  color: ${(props) => props.theme.colors.danger};
`;
